import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import classNames from 'classnames';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Card from '@mui/material/Card';

import AddDecoteRetourExcluDialog from './AddDecoteRetourExcluDialog';

import DeleteDecoteRetourExcluDialog from './DeleteDecoteRetourExcluDialog';
import { green } from '@mui/material/colors';

const styles = theme => ({
    root: {
        margin: 0,
        padding: 0
    },
    table: {
        //minWidth: 700
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },
    link: theme.style.link,
    administrationHeaderContainer: {
        display: 'flex',
        width: '100%'
    },
    administrationHeaderItemLeft: {
        flex: '1 1 auto'
    },
    administrationHeaderItemRight: {
        flex: '0 1 auto'
    },
    deleting: {
        background: 'red'
    },
    nowrapCell: {
        whiteSpace: 'nowrap'
    },
    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },
    actionContainer: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row-reverse',
        marginBottom: theme.spacing(3)
    }
});

class AdministrationDecoteRetourExclus extends React.Component {
    render() {
        let {
            classes, decoteRetourExclus, niveaux,
            addDecoteRetourExcluDialogOpen, onOpenAddDialog, onCloseAddDialog, addDecoteRetourExclu,
            deleteDecoteRetourExcluDialogOpen, onOpenDeleteDialog, onCloseDeleteDialog, deleteDecoteRetourExclu, decoteRetourExcluToDelete
        } = this.props;

        return (
            <React.Fragment>
                {addDecoteRetourExcluDialogOpen && <AddDecoteRetourExcluDialog niveaux={niveaux} onClose={onCloseAddDialog} onClickSave={addDecoteRetourExclu} />}
                {deleteDecoteRetourExcluDialogOpen && <DeleteDecoteRetourExcluDialog niveaux={niveaux} onClose={onCloseDeleteDialog} onClickDelete={deleteDecoteRetourExclu} decoteRetourExclu={decoteRetourExcluToDelete} />}


                <Card className={classNames(classes.paper)}>
                    <div className={classes.administrationHeaderContainer}>
                        <Typography gutterBottom variant="h5" className={classes.administrationHeaderItemLeft}>
                            Administration des exclusions pour les décôtes au retour
                    </Typography>
                        <Button className={classes.administrationHeaderItemRight} onClick={onOpenAddDialog}>Nouveau</Button>
                    </div>

                    <Paper className={classes.root}>
                        <Table className={classes.table} size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Niveau</TableCell>
                                    <TableCell>Code</TableCell>
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {decoteRetourExclus.map(decoteRetourExclu => {
                                    let niveau = niveaux.find(n => n.id === decoteRetourExclu.niveau);
                                    return (
                                        <TableRow key={decoteRetourExclu.id} className={decoteRetourExcluToDelete && decoteRetourExcluToDelete.id === decoteRetourExclu.id ? classes.deleting : ''}
                                            hover
                                        >
                                            <TableCell>{niveau.libelle}</TableCell>
                                            <TableCell>{decoteRetourExclu.code}</TableCell>
                                            <TableCell>
                                                <Button onClick={e => onOpenDeleteDialog(decoteRetourExclu.id)}>Supprimer</Button>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </Paper>
                </Card>
            </React.Fragment>
        );
    }
}

AdministrationDecoteRetourExclus.propTypes = {
    classes: PropTypes.object.isRequired,
    niveaux: PropTypes.array.isRequired,
    decoteRetourExclus: PropTypes.array.isRequired
};

export default withStyles(styles)(AdministrationDecoteRetourExclus);